import { render } from "./dispatch-grid.vue?vue&type=template&id=6b3af77c&scoped=true"
import script from "./dispatch-grid.vue?vue&type=script&lang=js"
export * from "./dispatch-grid.vue?vue&type=script&lang=js"

import "./dispatch-grid.vue?vue&type=style&index=0&id=6b3af77c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3af77c"]])

export default __exports__